export default {"src":"/_next/static/media/logo-5.04895c60.svg","height":45,"width":64,"blurWidth":0,"blurHeight":0};